import React, { memo } from 'react';
import { NodeProps } from 'reactflow';
import { TriggerNodeData } from '../../types/nodes';
import N8NStyleNode from './N8NStyleNode';

const ModernTriggerNode = memo(({ data, selected }: NodeProps<TriggerNodeData>) => {
  const getIcon = () => {
    const icons: Record<string, string> = {
      'message_received': '💬',
      'keyword': '#️⃣',
      'schedule': '⏰',
      'webhook': '🔗',
      'group_message': '👥',
      'group_join': '👋',
      'group_leave': '🚪',
    };
    return icons[data.triggerType] || '💬';
  };

  const getLabel = () => {
    const labels: Record<string, string> = {
      'message_received': 'Messaggio Ricevuto',
      'keyword': 'Parola Chiave',
      'schedule': 'Programmato',
      'webhook': 'Webhook',
      'group_message': 'Messaggio Gruppo',
      'group_join': 'Ingresso Gruppo',
      'group_leave': 'Uscita Gruppo',
    };
    return labels[data.triggerType] || data.label;
  };

  const getSubtitle = () => {
    const config = data.config || {};
    if (config.keyword) return `"${config.keyword}"`;
    if (config.schedule) return config.schedule;
    if (config.groupName) return config.groupName;
    if ((data as any).description) return (data as any).description;
    return 'Trigger';
  };

  return (
    <N8NStyleNode
      selected={selected}
      icon={getIcon()}
      label={getLabel()}
      subtitle={getSubtitle()}
      color="#10b981"
      handles={{ source: true, target: false }}
    />
  );
});

ModernTriggerNode.displayName = 'ModernTriggerNode';

export default ModernTriggerNode;
